import config from '../config'

// TM: Updated for hash and search sources for parameters
export const getURLParameterByName = (name) => {
    // look for a hash parameter
    // eslint-disable-next-line
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")
    const regex = new RegExp("[\\#&]" + name + "=([^&#]*)"),
        results = regex.exec(window.location.hash)
    let value = (results === null) ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))

    // if not a hash, locate by URL Query parameter
    if(value === '') {
        value = new URLSearchParams(window.location.search).get(name);
        if(value) {
            value = decodeURIComponent(value);
        }
    }
    return value;
}

export const fetchWrapper = async (url, init) => {
    const response = await fetch(url, init)
    const json = await response.json()
    return response.ok ? json : Promise.reject(json)
}

export const validateSubscription = (customerId, applicationId) => {
    return fetchWrapper(config.endpoints.subscription, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ customerId, applicationId })
    })
}

// Generates a cryptographically random PKCE code_verifier (RFC 7636)
// Length is random between 43 and 128 characters using unreserved characters [A-Z a-z 0-9 - . _ ~]
export const generateCodeVerifier = () => {
    const unreservedChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~'
    const length = Math.floor(Math.random() * (128 - 43 + 1)) + 43
    const randomBytes = crypto.getRandomValues(new Uint8Array(length))
    return Array.from(randomBytes).map(b => unreservedChars[b % unreservedChars.length]).join('')
}

// Computes the PKCE code_challenge using S256 method (RFC 7636)
// code_challenge = BASE64URL-ENCODE(SHA256(ASCII(code_verifier)))
export const generateCodeChallenge = async (codeVerifier) => {
    const encoded = new TextEncoder().encode(codeVerifier)
    const digest = await crypto.subtle.digest('SHA-256', encoded)
    return btoa(String.fromCharCode(...new Uint8Array(digest)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '')
}

// Initiates a PKCE authorization code flow redirect (RFC 7636)
// Generates a fresh verifier/challenge/state, stores them, then redirects to the Genesys auth endpoint
export const initiatePkceFlow = async (env) => {
    const codeVerifier = generateCodeVerifier()
    sessionStorage.setItem('pkce-code-verifier', codeVerifier)
    const codeChallenge = await generateCodeChallenge(codeVerifier)
    const state = crypto.randomUUID()
    sessionStorage.setItem('pkce-state', state)

    const params = new URLSearchParams({
        response_type: 'code',
        client_id: config.purecloud.clientId,
        redirect_uri: `${window.location.protocol}//${window.location.host}`,
        code_challenge: codeChallenge,
        code_challenge_method: 'S256',
        state
    })
    window.location = `https://login.${env}/oauth/authorize?${params.toString()}`
}

export default {
    getURLParameterByName,
    fetchWrapper,
    validateSubscription,
    generateCodeVerifier,
    generateCodeChallenge,
    initiatePkceFlow
}